import React from 'react';
import Table from 'react-bootstrap/Table';

import Display from '../../util/Display';
import DisplayPhone from '../common/DisplayPhone';
import DisplayEmail from '../common/DisplayEmail';

import './ContactPreview.css';

/**
 * this will show lead image and all primary information
 */
class ContactDetails extends React.Component {

  constructor(props) {
    super(props);
    this.setContactInfo(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.contact && props.contact.id !== this.id) {
      this.setContactInfo(props);
    }
  }

  setContactInfo = props => {
    this.contactScore = 0;
    if (props.contact !== undefined && props.contact.contact_score !== undefined) {
      this.contactScore = props.contact.contact_score;
    }

    const field = 'responsible_person';
    this.owners = Display.FieldValue(props.contact, field, props.model.fields);

    var phones = props.contact.phone;
    this.phones = [];
    if (phones !== '' && phones !== '~~') {
      phones = phones.substring(1, phones.length - 1);
      phones = phones.split('~');
      this.phones = phones.map(phone => <DisplayPhone key={`p_d_${phone}`} phone={phone} />);
    }

    var emails = props.contact.email;
    this.emails = [];
    if (emails !== '' && emails !== '~~') {
      emails = emails.substring(1, emails.length - 1);
      emails = emails.split('~');
      this.emails = emails.map(email => <DisplayEmail key={`p_e_${email}`} email={email} />);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-3 text-center">
          <img src={process.env.PUBLIC_URL + '/images/user.png'} alt="user" />
          {this.contactScore !== 0 &&
            <span className="userbadge badge badge-danger badge-mini rounded-circle">
              {this.contactScore}
            </span>
          }
        </div>

        <div className="col-md-6 leadsec">
          <Table className="table-sm table-borderless">
            <tbody>
              <tr> <th>Contact Owner</th> <td>{this.owners}</td> </tr>
              <tr> <th>Phone</th> <td>{this.phones}</td> </tr>
              <tr> <th>Email</th> <td>{this.emails}</td> </tr>
              <tr>
                <th>Address</th>
                <td>
                  {Display.FieldValue(
                    this.props.contact,
                    "address",
                    this.props.model.fields
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}
export default ContactDetails;